module.exports = __webpack_public_path__ + "img/bereg.8c716e28.png";